import React, { useState, useEffect } from 'react';
import {
  Box,
  IconButton,
} from '@mui/material';
import {
  ChevronLeft,
  ChevronRight
} from '@mui/icons-material';
import { PartInfo } from './PartInfo';
import { PartInfo as PartInfoType } from '../types';
import { useImagePreloader } from '../hooks/useImagePreloader';

interface PartCarouselProps {
  parts: PartInfoType[];
}

export const PartCarousel: React.FC<PartCarouselProps> = ({
  parts,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const imageUrls = parts.map(part => part.imageUrl).filter(Boolean);
  useImagePreloader(imageUrls);

  useEffect(() => {
    setCurrentIndex(0);
  }, [parts]);

  const handlePrevious = () => {
    setCurrentIndex(prev => prev > 0 ? prev - 1 : parts.length - 1);
  };

  const handleNext = () => {
    setCurrentIndex(prev => prev < parts.length - 1 ? prev + 1 : 0);
  };

  if (parts.length === 0) return null;

  return (
    <Box sx={{ 
      width: '100%',
      maxWidth: 900,
      mx: 'auto',
      mb: 4
    }}>
      {/* Main Carousel Content */}
      <Box sx={{ position: 'relative', minHeight: 500 }}>
        {parts.map((part, index) => (
          <Box
            key={part.id}
            sx={{
              position: index === currentIndex ? 'relative' : 'absolute',
              top: index === currentIndex ? 'auto' : 0,
              left: index === currentIndex ? 'auto' : 0,
              width: '100%',
              opacity: index === currentIndex ? 1 : 0,
              visibility: index === currentIndex ? 'visible' : 'hidden',
              transition: 'opacity 0.4s ease-in-out',
              zIndex: 0,
            }}
          >
            <PartInfo part={part} />
          </Box>
        ))}

        {/* Navigation Arrows - For multiple parts */}
        {parts.length > 1 && (
          <>
            <IconButton
              onClick={handlePrevious}
              sx={{
                position: 'absolute',
                left: -20,
                top: '50%',
                transform: 'translateY(-50%)',
                bgcolor: 'background.paper',
                boxShadow: 2,
                width: 48,
                height: 48,
                '&:hover': {
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  boxShadow: 3
                }
              }}
            >
              <ChevronLeft fontSize="large" />
            </IconButton>

            <IconButton
              onClick={handleNext}
              sx={{
                position: 'absolute',
                right: -20,
                top: '50%',
                transform: 'translateY(-50%)',
                bgcolor: 'background.paper',
                boxShadow: 2,
                width: 48,
                height: 48,
                '&:hover': {
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  boxShadow: 3
                }
              }}
            >
              <ChevronRight fontSize="large" />
            </IconButton>
          </>
        )}
      </Box>
    </Box>
  );
};
